import { defaultDistrict } from "src/pages/AdministrativeBoundaries/utils";

export const mapDistrictToDataTable = (data, districtId) => {
  return data.filter((district) => district.id !== defaultDistrict.id);
};

export const districtColumns = [
  { key: "districtName", label: "District Name", align: "center" },
  { key: "districtCode", label: "District Code", align: "center" },
];

export const isSelect = (districtId, item) => {
  if (item.id === districtId) {
    return {
      background: "#62b4ff",
    };
  }

  return {};
};
